module.exports = __webpack_public_path__ + "static/media/img_prn17.b36ab7e5.png";